
import React , { useEffect} from "react";
import FlexContainer from "../UI/FlexContainer/FlexContainer"
import  {connect} from "react-redux"
import Spinner from "../Spinner/Spinner";
import * as actions from "../../store/actions/index"
import ProductCard from "../ProductCard/ProductCard";
import NavBar1 from "../Navbar1/NavBar1";
import Sidebar from "../SideBar/SideBar"
import Footer from "../Footer/Footer";

const Whislist = (props)=>{


    useEffect(()=>{
         
        props.onGetWishlistProducts(props.userId)

    },[])

    const handleLoadMoreWishlistProducts = ()=>{
        props.onLoadMoreWishlist(
            props.leadsexhaustedwishlist,
            props.lastDocwishlist,
            props.limitwishlist
            )
    }

    if(props.loading){
        return <Spinner/>
    }

    return (
        <>

            <NavBar1/>
            <Sidebar>
                <Footer>

                {props.wishlistproducts.length > 0 ?
                    <div className="container container-md" style={{ padding: "20px" }}>
                       <FlexContainer>

                       {props.wishlistproducts.map((product) => (
                           <>
                            <ProductCard product={product} />
                           
                           </>
                           
                       ))
                        }
                    

                       </FlexContainer>
                       {!props.leadsexhaustedwishlist ? (
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() =>
                            handleLoadMoreWishlistProducts()
                            }
                            disabled={props.loadMoreWhislist}
                          >
                            {props.loadMoreWhislist?"Loading":"Load More"}
                          </button>
                        </div>
                      ) : null}
                           
                        
                    </div> : <div className="w-100 text-center mt-4">
                            <h4>Your Wishlist is Empty</h4>
                        </div>} 

                </Footer>

            </Sidebar>

                
        
        </>
    )
}

const mapStateToProps = state =>{
    return {
        userId:state.auth.userId,
        user: state.auth.user,
        wishlist:state.account.wishlist,
        wishlistproducts:state.account.wishlistproducts,
        loading:state.account.loading,
        addBtnLoading:state.account.addBtnLoading,
        leadsexhaustedwishlist: state.account.leadsexhaustedwishlist,
        limitwishlist: state.account.limitwishlist,
        lastDocwishlist: state.account.lastDocwishlist,
        loadMoreWhislist:state.account.loadMoreWhislist
    }
}

const mapDisptachToProps = dispatch =>{
    return {
        onGetWishlistProducts: (userId) => dispatch(actions.onGetWishlistProducts(userId)),
        onLoadMoreWishlist:(leadsexhaustedwishlist,lastDocwishlist,limitwishlist )=>dispatch(actions.onLoadMoreWishlist(leadsexhaustedwishlist,lastDocwishlist,limitwishlist))
        
    } 
}

export default connect(mapStateToProps, mapDisptachToProps)(Whislist);

